"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.937 3.61a1.5 1.5 0 0 0-1.874 0l-6.125 4.9A2.5 2.5 0 0 0 4 10.46v9.04A1.5 1.5 0 0 0 5.5 21h3a1.5 1.5 0 0 0 1.5-1.5V17a2 2 0 0 1 4 0v2.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-9.04a2.5 2.5 0 0 0-.938-1.952z"
}), 'HomeFilled');
